// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__JnaVO","orderBtn":"Button_orderBtn__ZLuwV"};